import Duck from "redux-ducks-ts"

export const login = new Duck("login", "cargo")
